import { render, staticRenderFns } from "./SchoolSubscriptionForm.vue?vue&type=template&id=03df06a5&scoped=true&"
import script from "./SchoolSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SchoolSubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSubscriptionForm.vue?vue&type=style&index=0&id=03df06a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df06a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03df06a5')) {
      api.createRecord('03df06a5', component.options)
    } else {
      api.reload('03df06a5', component.options)
    }
    module.hot.accept("./SchoolSubscriptionForm.vue?vue&type=template&id=03df06a5&scoped=true&", function () {
      api.rerender('03df06a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/SchoolSubscriptionForm.vue"
export default component.exports